import { lazyLoad } from 'utils/loadable';

export const TaskManagementLoadable = lazyLoad(
  () => import('./TaskManagement'),
  module => module.TaskManagement,
);
